export const permissionDeniedMessages = {
    camera: "Woopsy, Kolmeo needs access to your camera. We need this permission so you can post photos to inspections or your timeline. Go to your permissions and enable camera roll.",
    photoLibrary: "Woopsy, Kolmeo needs access to your photo gallery. We need this permission so you can upload photos to inspections or your timeline. Go to your permissions and enable camera roll.",
};
